"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewBackendDataProvider = useViewBackendDataProvider;
const useViewList_1 = require("./useViewList");
function useViewBackendDataProvider(viewName, mapEntityFilterData) {
    return (request) => {
        const response = (0, useViewList_1.useViewList)(viewName, {
            filter: mapEntityFilterData(request.filterData),
            orderBy: [{ column: request.sortColumnKey, desc: request.sortColumnDesc }],
            limit: request.limit,
            offset: request.offset,
        });
        return {
            data: response.data
                ? {
                    filteredRowCount: response.data.total,
                    rows: response.data.rows,
                }
                : undefined,
            error: response.error,
            isLoading: response.isLoading,
            reload: response.mutate,
        };
    };
}
